import { Common, ApiBind } from './common.model';

export class PlacementRelationSDKVersionGroup extends Common {

  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'platform_id' })
  platformId: number;

  @ApiBind({ column: 'sdk_version_group_id' })
  sdkVersionGroupId: number;
}
